/* eslint-disable camelcase */
import { makeAutoObservable } from 'mobx';
import AccountModel from './AccountModel';
import MessageModel from './MessageModel';
import UserModel from './UserModel';
import ContactsModel from './ContactsModel';

class ConversationModel {
  id = 0;

  channelType = 1;

  channelID = 0;

  channelUser = 0;

  isUserSubscribed = 0;

  channelContext = 0;

  status = 0;

  created_at = null;

  updated_at = null;

  // deleted_at = null;

  manager_id = 0;

  messagesCount = 0;

  manager = {
    name: '',
    soname: '',
    surname: '',
  };

  unreaded = 0;

  unviewed = 0;

  conversationStatus = 0;

  account = {};

  messages = [];

  channel = {};

  contacts = {};

  constructor(conversation, autoObservable = true) {
    this.id = conversation.id;
    this.channelType = conversation.channelType;
    this.channelID = conversation.channelID;
    this.channel = conversation.channel;
    this.channelUser = conversation.channelUser;
    this.isUserSubscribed = conversation.isUserSubscribed;
    this.channelContext = conversation.channelContext;
    this.status = conversation.status;
    this.created_at = conversation.created_at;
    this.updated_at = conversation.updated_at ? new Date(conversation.updated_at) : null;
    // this.deleted_at = conversation.deleted_at;
    this.manager_id = conversation.manager_id;
    this.manager = new UserModel(conversation.manager, autoObservable);
    // this.messages = conversation.messages;
    this.unreaded = conversation.unreaded;
    this.unviewed = conversation.unviewed;
    this.conversationStatus = conversation.conversationStatus;
    this.account = new AccountModel(conversation.account, autoObservable);
    this.contacts = new ContactsModel(conversation.contacts);
    // this.messages = [];// conversation.messages ? conversation.messages.map((message) => new MessageModel(message)) : [];
    if (autoObservable) {
      makeAutoObservable(this);
    }
  }
}

export default ConversationModel;
